import { render, staticRenderFns } from "./CdkSearchProvider.vue?vue&type=template&id=2cac75b8&"
import script from "./CdkSearchProvider.vue?vue&type=script&lang=ts&"
export * from "./CdkSearchProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
